import { Search } from "lucide-react";
import { CATEGORY_LABELS } from "../../lib/constants";

const CATEGORIES = [
  { value: "", label: "All" },
  ...Object.entries(CATEGORY_LABELS).map(([value, label]) => ({ value, label })),
];

export default function FilterBar({ filters, onChange }) {
  const update = (key, value) => onChange({ ...filters, [key]: value });

  return (
    <div className="space-y-3 mb-6">
      <div className="relative">
        <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-walnut-light" />
        <input
          type="text"
          placeholder="Search posts..."
          value={filters.q || ""}
          onChange={(e) => update("q", e.target.value)}
          className="w-full pl-10 pr-4 py-2.5 bg-cream border border-stone rounded-md text-sm text-walnut placeholder:text-walnut-light/60 focus:outline-none focus:ring-2 focus:ring-terracotta/30 focus:border-terracotta"
        />
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1">
        {CATEGORIES.map(({ value, label }) => (
          <button
            key={value}
            onClick={() => update("category", value)}
            className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
              (filters.category || "") === value
                ? "bg-terracotta text-white"
                : "bg-cream text-walnut-light border border-stone hover:border-terracotta/30"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap gap-3 items-center">
        <select
          value={filters.type || ""}
          onChange={(e) => update("type", e.target.value)}
          className="px-3 py-1.5 bg-cream border border-stone rounded-md text-sm text-walnut focus:outline-none focus:ring-2 focus:ring-terracotta/30"
        >
          <option value="">All Types</option>
          <option value="request">Requests</option>
          <option value="offer">Offers</option>
        </select>
        <select
          value={filters.urgency || ""}
          onChange={(e) => update("urgency", e.target.value)}
          className="px-3 py-1.5 bg-cream border border-stone rounded-md text-sm text-walnut focus:outline-none focus:ring-2 focus:ring-terracotta/30"
        >
          <option value="">All Urgency</option>
          <option value="critical">Critical</option>
          <option value="high">High</option>
          <option value="medium">Medium</option>
          <option value="low">Low</option>
        </select>
        <div className="flex items-center gap-2">
          <label className="text-xs text-walnut-light whitespace-nowrap">Radius:</label>
          <input
            type="range"
            min="1"
            max="100"
            value={filters.radius || 50}
            onChange={(e) => update("radius", Number(e.target.value))}
            className="w-24 accent-terracotta"
          />
          <span className="text-xs text-walnut-light w-12">{filters.radius || 50} km</span>
        </div>
      </div>
    </div>
  );
}
